<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Icon from "$lib/components/Icon/Icon.svelte";
  import { linkTo } from "$lib/utils/url";
  import { _ } from "svelte-i18n";

  export let icon = "";
  export let text = "";
  export let href = "";
  export let underline = true;
  export let theme = "on-background";
  export let iconTheme = theme;
  export let hoverTheme = theme;
  // Should link be standard (lowercase, not bold) or not (uppercase, bold)
  export let standard = false;
  export let newTab = false;
  export let inline = false;
  export let noMargin = false;
  export let iconLeft = true;
  export let iconStyle = "rounded";
  // To avoid duplications of linkTo when already used elsewhere in the prop being passed
  export let processedUrl = false;
  export let colour: string = "";
  export let twoImageHero: boolean = false;

  let isHovered = false;
</script>

<style lang="scss">
  .link {
    text-decoration: none;
    display: flex;
    align-items: baseline;
    &--icon {
      &__left {
        margin-right: 6px;
      }

      &__right {
        margin-left: 6px;
      }

      &__no-text {
        margin: 0;
      }
    }

    &--inline {
      display: inline;
    }

    &--nomargin {
      margin: 0;
    }
  }
</style>

<div>
  <a
    class="link {inline ? 'link--inline' : ''} {noMargin
      ? 'link--nomargin'
      : ''}"
    href={processedUrl ? href : linkTo(href)}
    on:mouseenter={() => (isHovered = true)}
    on:mouseleave={() => (isHovered = false)}
    target={newTab ? "_blank" : null}
    rel={newTab ? "noopener noreferrer" : null}
    aria-label={newTab ? `${text} (${$_("opensNewTab")})` : text}
    {...$$restProps}
  >
    {#if iconLeft && icon}
      <div class="link--icon__left {text === '' ? 'link--icon__no-text' : ''}">
        <Icon
          color={isHovered
            ? `var(--${hoverTheme})`
            : colour && twoImageHero
              ? colour
              : `var(--${iconTheme})`}
          {icon}
          {iconStyle}
        />
      </div>
    {/if}
    <Typography
      theme={`${isHovered ? `${hoverTheme}` : `${theme}`}`}
      component="span"
      variant={standard ? "body1" : "button1"}
      {underline}
    >
      {#if twoImageHero}
        <div style="color: {colour}">
          {text}
        </div>
      {:else}
        {text}
      {/if}
    </Typography>
    {#if !iconLeft && icon}
      <div class="link--icon__right {text === '' ? 'link--icon__no-text' : ''}">
        {#if !twoImageHero}
          <Icon
            color={`${
              isHovered ? `var(--${hoverTheme})` : `var(--${iconTheme})`
            }`}
            {icon}
            {iconStyle}
          />
        {:else if twoImageHero}
          <Icon
            color={`${
              colour
                ? colour
                : !colour
                  ? `var(--${hoverTheme})`
                  : `var(--${iconTheme})`
            }`}
            {icon}
            {iconStyle}
          />
        {/if}
      </div>
    {/if}
  </a>
</div>
